import TableLoader from "../../../../general/table/tableLoader";
import EmptyRow from "../../../../general/table/emptyRow";
import React from "react";
import PatientAllergyTableRowItem from "./patientAllergyTable_rowItem";

type PatientAllergiesTableProps = {
  dataList?: any;
  dataListTitles: string[];
  isRequesting: boolean
  readonly: boolean
}

const PatientAllergiesTable = ({
  dataList,
  dataListTitles,
  isRequesting,
  readonly
}: PatientAllergiesTableProps) => {
  const _dataListTitles = dataListTitles.map((item, i) => <td key={i}>{item}</td>),
    _dataList = dataList?.data && dataList?.data.length > 0 && dataList?.data.map((item: any, i: number) => {
      return <PatientAllergyTableRowItem item={item} key={i} readonly={readonly}/>
    });

  return (
    <table>
      <thead>
      <tr>
        {_dataListTitles}
      </tr>
      </thead>
      <tbody>
      {isRequesting ?
        <TableLoader colSpan={dataListTitles.length}/> :
        _dataList ? _dataList : <EmptyRow colSpan={dataListTitles.length} content={''}/>
      }
      </tbody>
    </table>
  )
}

export default PatientAllergiesTable;
